import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";

const PAID = ["paid", "shipped", "ready_for_pickup", "delivered"];

const Shell = ({ icon, title, text, t, testid }) => (
  <div className="mx-auto max-w-lg px-4 py-20 text-center" data-testid={testid}>
    <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#EFE9FB]">{icon}</div>
    <h1 className="mt-5 text-3xl font-bold">{title}</h1>
    {text && <p className="mt-3 text-[#4B4763]">{text}</p>}
    <div className="mt-8 flex items-center justify-center gap-3"><Link to="/account?tab=orders" className="btn-violet" data-testid="result-orders-btn">{t("p3.result.goOrders")}</Link><Link to="/cerca" className="btn-ghost">{t("p3.result.back")}</Link></div>
  </div>
);

export const PaymentResult = () => {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [st, setSt] = useState(null);
  useEffect(() => {
    let n = 0, stop = false;
    const q = params.get("session_id") ? `session_id=${params.get("session_id")}` : `order_id=${params.get("order_id")}`;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status?${q}`);
        setSt(data.status);
        if (data.status === "pending_payment" && n++ < 15 && !stop) setTimeout(poll, 2000);
      } catch { setSt("failed"); }
    };
    poll();
    return () => { stop = true; };
  }, [params]);
  if (!st || st === "pending_payment") return <Shell testid="payment-pending" t={t} icon={st ? <Clock className="h-8 w-8 text-[#3B1272]" /> : <Loader2 className="h-8 w-8 animate-spin text-[#3B1272]" />} title={st ? t("p3.result.pending") : t("p3.result.checking")} />;
  if (PAID.includes(st)) return <Shell testid="payment-success" t={t} icon={<CheckCircle2 className="h-8 w-8 text-emerald-600" />} title={t("p3.result.paid")} text={t("p3.result.paidText")} />;
  return <Shell testid="payment-failed" t={t} icon={<XCircle className="h-8 w-8 text-[#E0533F]" />} title={st === "expired" ? t("p3.result.expired") : t("p3.result.failed")} />;
};

export const PaymentCancelled = () => {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [done, setDone] = useState(false);
  const once = useRef(false);
  useEffect(() => {
    const id = params.get("order_id");
    if (!id || once.current) return;
    once.current = true;
    api.post(`/checkout/${id}/cancel`).catch(() => {}).finally(() => setDone(true));
  }, [params]);
  return <Shell testid="payment-cancelled" t={t} icon={done ? <XCircle className="h-8 w-8 text-[#E0533F]" /> : <Loader2 className="h-8 w-8 animate-spin" />} title={t("p3.result.cancelled")} text={t("p3.result.cancelledText")} />;
};
